const getUserPhotoUrl = (photoId: string, dimensions: '100' | '160' | '200' = '100', env: string = 'brighttalkprod'): string | null => {

    if (!photoId) return null

    return `https://res.cloudinary.com/${env}/image/upload/t_scale_${dimensions}x${dimensions}/${photoId}.jpg`
}

export default getUserPhotoUrl